import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import ProtectedRoute from 'auth/ProtectedRoute';
import PatientDocumentImageUpload from 'components/clinical-data/PatientDocumentImageUpload';
import LoaderComponent from 'components/LoaderComponent';
import CovidTestResultImageUpload from 'components/patient-entry/CovidTestResultImageUpload';
import TestPanelResultImageUpload from 'components/patient-entry/TestPanelResultImageUpload';
import React from 'react'
import { RouterProps } from 'react-router';
import { Route, Switch } from 'react-router-dom'
import ErrorPage from 'routes/ErrorPage';
import Home from 'routes/Home';
import Login from 'routes/login/Login';
import Register from 'routes/Register';
import styled from 'styled-components';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const StyledContainer = styled.div`
  height: 100vh !important;
  overflow: hidden;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    overflow: auto !important;
  }
`;

const StyledLoaderWrapper = styled.div`
  padding-top: 20px;
`;

interface Props extends RouterProps, AuthConsumerRenderProps {
}

const Main = (props: Props) => {

  const queryParams = new URLSearchParams(props.history.location.search);

  const loadingData = props.fetchingUser || props.fetchingMessages;

  const renderLoader = (): React.ReactNode => {
    return (
        <StyledLoaderWrapper>
          <LoaderComponent active/>
        </StyledLoaderWrapper>
    )
  };

  const renderApp = (): React.ReactNode => {
    return (
        <Switch>
          <Route path='/test-result-image-upload/:token' component={CovidTestResultImageUpload}/>
          <Route path='/test-panel-result-image-upload/:token' component={TestPanelResultImageUpload}/>
          <Route path='/patient-document-image-upload/:token' component={PatientDocumentImageUpload}/>
          <Route path='/error' component={ErrorPage}/>
          <Route path='/login' component={Login}/>
          <Route path='/registration' component={Register} />
          <Route path='/reset-password' component={() => (<Login token={queryParams.get("token")}/>)}/>
          <ProtectedRoute path='/' component={Home}/>
        </Switch>
    )
  };

  const renderContent = (): React.ReactNode => {
    return loadingData ? renderLoader() : renderApp();
  };

  return (
      <StyledContainer>
        {renderContent()}
      </StyledContainer>
  )
};

export default withRouterWorkaround(withAuthContext(Main));
